import get from 'lodash/get';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import currencyFormatter from 'currency-formatter';
import User from 'yoda-site-components/lib/helpers/User/User';
import {
    CURRENCY_US,
    MAXALLOWEDGIFTCARD,
    ADJUSTMENT_TYPE_NEW_CUSTOMER,
} from 'yoda-checkout-components/lib/common/Constants';
import { formatPhoneNumber } from 'yoda-account-components/lib/helpers/PhoneNumberFormatter/PhoneNumberFormatter';
import {
    GC_CTA_MESSAGE_1,
    GC_CTA_MESSAGE_2,
    ADD_ANOTHER_GIFT_CARD,
    ADD_GIFT_CARD,
    TEMPCARDNUMBERRENTRYREQUIRED_AUTH,
    UNVERIFIED_AUTH,
} from 'yoda-checkout-components/lib/common/LabelConstants';
import {
    imagePath,
    isGiftCardOrder,
    getFormattedValue,
} from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import { isAgentLogged } from 'yoda-core-components/lib/helpers/Utils/Utils';
import * as actionTypes from '../actionTypes/NewPaymentActionTypes';
import {
    validateRequired,
    validateCreditCardFormField,
    validateGiftCardFormField,
} from '../helpers/Utils/Utils';
import PaymentService from '../services/PaymentService';
import ShippingService from '../services/ShippingService';
import PaymentConstants from '../helpers/PaymentConstants';
import { isMarketplaceRestrictedCardEntry } from '../helpers/PaymentCardRestrictionUtils';

export default function NewPaymentReducer(state = {}, action) {
    // NOSONAR
    /*
     * {
     *      'creditCardUserInputInfo': {
     *          'cardInfo': {
     *              'id': '',
     *              'number': '',
     *              'expMonth': '',
     *              'expYear': '',
     *              'cvv': '',
     *              'type': 'visa/master/jcp',
     *              'cardPLCCCVVImageURL': '',
     *              'relationShipId': '',
     *              'isITRM': true/false,
     *              'cvvReentryRequired': true/false,
     *              'authMessageInfo': {
     *                  title: '',
     *                  content: '',
     *              },
     *              'isExpressCheckout': true/false,
     *              'imageURL': '',
     *              'saveCardToProfile': {
     *                  show: true/false,
     *                  selected: true/false,
     *              },
     *              'IconList': {
     *                  jcpCardImage: '',
     *                  dualCardImage: '',
     *                  visaCardImage: '',
     *                  masterCardImage: '',
     *                  discoverCardImage: '',
     *                  amexCardImage: '',
     *              },
     *              'showExpressCheckout': true/false,
     *              'expMonthOptions': [{value:1}, ..],
     *              'expYearOptions': [{value:2019}, ..],
     *              'isNortonSecurityBadge': true/false,
     *          },
     *          'errorCardInfo': {
     *              'number': '',
     *              'expMonth': '',
     *              'expYear': '',
     *              'cvv': '',
     *              'emailId': '',
     *              'phone': '',
     *          },
     *          'fieldTouchedInfo': {
     *              'number': true/false,
     *              'expMonth': true/false,
     *              'expYear': true/false,
     *              'cvv': true/false,
     *          },
     *          'emailId': '',
     *          'enableEmailSubscription': true/false,
     *          'billingAddress': {
     *              'firstName': '',
     *              'lastName': '',
     *              'lineOne': '',
     *              'zip': '',
     *              'state': '',
     *              'city': '',
     *              'country': '',
     *              'lineTwo': '',
     *              'lineThree': '',
     *              'company': '',
     *              'phone': '',
     *              'secondaryPhone': '',
     *           },
     *      },
     *      'isPaypalOrApplePaySelected': true/false,
     *      'specialDiscountPercentageOff': '',
     *      'pickupPersonInfo' : {
     *          'alternatePickPersonChecked':true/false,
     *          'firstName': '',
     *          'lastName': '',
     *          'email': '',
     *          'phone': '',
     *          'errorInfo': {
     *              'firstName': '',
     *              'lastName': '',
     *              'email': '',
     *              'phone': '',
     *         },
     *      },
     *      'giftCardInfo' {
     *          appliedGiftCardList: [{
     *              number: '',
     *              value: '',
     *              amount: '',
     *              balance: '',
     *              id: '',
     *              href: '',
     *          }],
     *             appGiftCardList: [{
     *             balance: '',
     *             giftCardNumber:'',
     *             pin:'',
     *         }]
     *          remainingBalanceMessage: '',
     *          showAddGiftCardLink: true/false,
     *          showGiftCardForm: true/false,
     *          buttonCTALabel: 'Apply Gift Card / Apply Another Gift Card',
     *          giftCardForm: {
     *              giftCardNumber: '',
     *              securityCode: '',
     *              errorInfo: {
     *                  giftCardNumber: '',
     *                  securityCode: '',
     *              }
     *          },
     *      }
     *      'selectedCardInfo': {
     *          'draftOrder.billing.creditCards[].cards[]'
     *      },
     *      'showEditCreditCardForm': true/false,
     *      'showNewCreditCardForm': true/false,
     *      'xStandardizationNotRequired': true/false,
     *      'showEditBillingAddressForm': true/false,
     *      'deleteConfirmation':{
     *          'showDeleteConfirmationModal': true/false,
     *          'paymentId': {},
     *      },
     *      'userPaymentList': [{
     *          'userName': 'firstName lastName',
     *          'imageUrl': '',
     *          'cardName': '',
     *          'type': '',
     *          'showDeleteLink': true/false,
     *          'showDefaultLabel': true/false,
     *          'selected': true/false,
     *          'paymentSource': {},
     *          'transientPayment': true/false,
     *          'isPromoFinanceApplied': true/false,
     *       },
     *      ],
     *      payPalEligible: true/false,
     *      isPartialGiftcardPayment: true/false,
     *      isPaypalPaymentAdded: true/false,
     *      orderEligibleForApplePay: true/false,
     *      showSameAsShippingAddressCheck: true/false,
     *      orderBillingInfo: {
     *          name: 'fistName lastName',
     *          addressLineOne: 'lineOne, lineTwo',
     *          addressLineTwo: 'city, state zip' or ' city, state'
     *          addressLineThree: 'international_country zip'
     *          phone: 'register user only',
     *          source: {}
     *      },
     *      pageRenderTime: Date,
     * }
     *
     */

    switch (
        action.type // NOSONAR
    ) {
        /**
         * Initialize empty credit card form for guest and register user
         */
        case actionTypes.INIT_EMPTY_CREDIT_CARD_FORM: {
            const { orderDetailsInfo } = action;
            const orderShippingList = get(orderDetailsInfo, 'data.delivery.groups', []);
            const orderShipping = find(orderShippingList, { type: 'HOME' }) || {};
            const userDefaultAddress = get(action, 'userDefaultAddress[0]', false);
            const initiatedFromAdjustment = get(action.options, 'initiatedFromAdjustment', false);
            /**
             * Should read billing address from order billing CC or if not read from shipping address.
             * if not read from unnamed address in order(this can happen with 0$ order with sdpu only item)
             * if not read from user default address which will passed from cartdetails saga (this can happen when user has address stored in profile without any paymenthod. and one SDPU item in cart. so when user lands in payment from cart there will be no address in order. So picked address from user profile)
             */
            let billingAddress =
                get(orderDetailsInfo, 'data.billing.creditCards.cards[0].address') ||
                get(orderDetailsInfo, 'data.billing.unnamed.address') ||
                orderShipping.address ||
                userDefaultAddress ||
                {};
            let showEditBillingAddressForm = isEmpty(billingAddress);
            const isPartialGiftcardPayment = PaymentService.isPartialGiftcardPayment(
                orderDetailsInfo
            );
            const isPaypalPaymentAdded = PaymentService.isPaypalPaymentAdded(orderDetailsInfo);
            const emailId = PaymentService.getEmailIdFromOrder(orderDetailsInfo);
            const showNewCreditCardForm = isPartialGiftcardPayment;
            const payPalEligible = PaymentService.isPaypalEligible(
                orderDetailsInfo,
                action.options
            );
            const orderEligibleForApplePay = orderDetailsInfo.applePayEligible;
            let showSameAsShippingAddressCheck = PaymentService.isShippingBillingAddressSame(
                orderDetailsInfo
            );

            let orderBillingInfo = {};
            if (isEmpty(billingAddress)) {
                /**
                 * Should read firstName, lastName and phone no from store shipping information if order doesn't have
                 * billing or shipping addrress
                 */
                const storeShippingInfo =
                    find(orderShippingList, { type: 'STORE' }) ||
                    find(orderShippingList, { type: 'BOPIS' }) ||
                    {};
                if (storeShippingInfo.pickup) {
                    orderBillingInfo.source = {
                        firstName: storeShippingInfo.pickup.firstName,
                        lastName: storeShippingInfo.pickup.lastName,
                        phone: storeShippingInfo.pickup.phone,
                        country: 'US',
                    };
                    billingAddress.phone = storeShippingInfo.pickup.phone;
                }
            } else {
                orderBillingInfo = PaymentService.getOrderBillingInfoUI(
                    billingAddress,
                    '',
                    action.options.isUserLoggedInSSR
                );
                // eslint-disable-next-line no-param-reassign
                delete action.options.isUserLoggedInSSR;
                showEditBillingAddressForm = false;
            }
            if (isPaypalPaymentAdded) {
                const billingPaypalAddress = get(
                    orderDetailsInfo,
                    'data.billing.paypal.address',
                    {}
                );
                orderBillingInfo = PaymentService.getOrderBillingInfoUI(
                    billingPaypalAddress,
                    isPaypalPaymentAdded
                );
                orderBillingInfo.imageURL = imagePath(action.options.context, 'paypal.svg');
                showSameAsShippingAddressCheck = false;
                showEditBillingAddressForm = false;
                billingAddress = billingPaypalAddress;
            }

            let isPaypalOrApplePaySelected =
                isPaypalPaymentAdded ||
                (state.isPaypalOrApplePaySelected && isPartialGiftcardPayment);
            if (action.options && action.options.initiateFromAddCCLink) {
                isPaypalOrApplePaySelected = false;
            }
            if (state.isBnplSelected) {
                isPaypalOrApplePaySelected = false;
                showEditBillingAddressForm = false;
            }
            // Reset PayPal selection if PayPal is no longer eligible
            if (!payPalEligible && state.isPaypalOrApplePaySelected) {
                isPaypalOrApplePaySelected = false;
            }
            const updatedState = {
                showNewCreditCardForm,
                showSameAsShippingAddressCheck,
                orderBillingInfo,
                payPalEligible,
                isPartialGiftcardPayment,
                isPaypalPaymentAdded,
                orderEligibleForApplePay,
                isPaypalOrApplePaySelected,
            };
            /**
             * Unselect payment if user click on add new credit card links
             */
            if (!isEmpty(state.userPaymentList) && isPartialGiftcardPayment) {
                updatedState.userPaymentList = PaymentService.selectedPaymentUpdateInPaymentList(
                    '',
                    state.userPaymentList
                );
            }

            if (
                (!initiatedFromAdjustment ||
                    (showEditBillingAddressForm && !state.showEditBillingAddressForm)) &&
                !action.options.doNotInitiateCreditCardForm
            ) {
                updatedState.selectedCardInfo = {};
                updatedState.showEditBillingAddressForm = showEditBillingAddressForm;
                const cardInfo = PaymentService.getCreditCardUIMapFromAPI(
                    {},
                    action.options.context
                );
                const creditCardUserInputInfo = {
                    errorCardInfo: {},
                    fieldTouchedInfo: {},
                    billingAddress,
                    cardInfo,
                    emailId,
                };

                creditCardUserInputInfo.billingAddress.phone = formatPhoneNumber(
                    creditCardUserInputInfo.billingAddress.phone
                );
                updatedState.creditCardUserInputInfo = creditCardUserInputInfo;
                updatedState.pageRenderTime = new Date().getTime();
            }

            if (showSameAsShippingAddressCheck && !updatedState.creditCardUserInputInfo) {
                updatedState.creditCardUserInputInfo = state.creditCardUserInputInfo || {};
                updatedState.creditCardUserInputInfo.billingAddress = orderBillingInfo.source;
                if (orderBillingInfo.source.phone) {
                    updatedState.creditCardUserInputInfo.billingAddress.phone = formatPhoneNumber(
                        orderBillingInfo.source.phone
                    );
                }
            }
            if (isAgentLogged()) {
                updatedState.showEditBillingAddressForm = true;
            }
            return { ...state, ...updatedState };
        }

        case actionTypes.UPDATE_DELETED_CC: {
            const { userPaymentList, creditCardUserInputInfo } = action;
            return { ...state, creditCardUserInputInfo, userPaymentList };
        }

        /**
         * Update payment method Type
         */
        case actionTypes.UPDATE_PAYMENT_METHOD_TYPE_SUCCESS: {
            const { methodType, billingAddress } = action;
            let isPaypalOrApplePaySelected = false;
            let isBnplSelected = false;
            let { showEditBillingAddressForm } = state;
            const creditCardUserInputInfo = state.creditCardUserInputInfo || {};
            creditCardUserInputInfo.errorCardInfo = {};
            if (methodType === 'paypal') {
                isPaypalOrApplePaySelected = true;
                showEditBillingAddressForm = state.isPaypalPaymentAdded
                    ? false
                    : showEditBillingAddressForm;
            } else if (methodType === 'bnpl') {
                isPaypalOrApplePaySelected = false;
                showEditBillingAddressForm = false;
                isBnplSelected = true;
            } else {
                showEditBillingAddressForm = isEmpty(billingAddress);
            }
            if (isAgentLogged()) {
                showEditBillingAddressForm = true;
            }
            const updatedState = {
                isPaypalOrApplePaySelected,
                showEditBillingAddressForm,
                creditCardUserInputInfo,
                isBnplSelected,
            };
            return { ...state, ...updatedState };
        }

        /**
         * Initialize update credit card form for guest user
         */
        case actionTypes.INIT_GUEST_UPDATE_CREDIT_CARD_FORM: {
            const { orderDetailsInfo } = action;
            const selectedCardInfo = get(orderDetailsInfo, 'data.billing.creditCards.cards[0]', {});
            const initiatedFromAdjustment = get(action.options, 'initiatedFromAdjustment', false);
            const currentUserInput = state.creditCardUserInputInfo;
            let cardInfo;
            if (
                currentUserInput &&
                !isEmpty(currentUserInput.cardInfo) &&
                !isEmpty(currentUserInput.fieldTouchedInfo)
            ) {
                cardInfo = currentUserInput.cardInfo;
            } else {
                cardInfo = PaymentService.getCreditCardUIMapFromAPI(
                    selectedCardInfo,
                    action.options.context
                );
            }
            const billingAddress =
                selectedCardInfo.address ||
                get(orderDetailsInfo, 'data.billing.paypal') ||
                get(orderDetailsInfo, 'data.billing.unnamed') ||
                {};
            const emailId = PaymentService.getEmailIdFromOrder(orderDetailsInfo);
            const showNewCreditCardForm = PaymentService.isPartialGiftcardPayment(orderDetailsInfo);
            const isPartialGiftcardPayment = PaymentService.isPartialGiftcardPayment(
                orderDetailsInfo
            );
            const isPaypalPaymentAdded = PaymentService.isPaypalPaymentAdded(orderDetailsInfo);
            const payPalEligible = PaymentService.isPaypalEligible(
                orderDetailsInfo,
                action.options
            );
            const orderEligibleForApplePay = orderDetailsInfo.applePayEligible;
            const showSameAsShippingAddressCheck = PaymentService.isShippingBillingAddressSame(
                orderDetailsInfo
            );
            const orderBillingInfo = PaymentService.getOrderBillingInfoUI(billingAddress);
            billingAddress.phone = formatPhoneNumber(billingAddress.phone);
            const isPaypalOrApplePaySelected =
                isPaypalPaymentAdded ||
                (state.isPaypalOrApplePaySelected && isPartialGiftcardPayment);

            const updatedState = {
                selectedCardInfo,
                showNewCreditCardForm,
                showSameAsShippingAddressCheck,
                orderBillingInfo,
                payPalEligible,
                isPartialGiftcardPayment,
                isPaypalPaymentAdded,
                isPaypalOrApplePaySelected,
                orderEligibleForApplePay,
            };

            if (!initiatedFromAdjustment) {
                const creditCardUserInputInfo = {
                    errorCardInfo: {},
                    fieldTouchedInfo: {},
                    billingAddress,
                    cardInfo,
                    emailId,
                };
                updatedState.creditCardUserInputInfo = creditCardUserInputInfo;
                updatedState.pageRenderTime = new Date().getTime();
            }
            return { ...state, ...updatedState };
        }

        /**
         * Initialize update credit card form for register user
         */
        case actionTypes.INIT_REGISTER_UPDATE_CREDIT_CARD_FORM: {
            const { userPaymentInfo } = action;
            const cardInfo = PaymentService.getCreditCardUIMapFromAPI(
                userPaymentInfo,
                action.options.context
            );
            const billingAddress = userPaymentInfo.transientPayment
                ? userPaymentInfo.orderPaymentInfo.address
                : userPaymentInfo.paymentSource.address;
            billingAddress.phone = formatPhoneNumber(billingAddress.phone);
            userPaymentInfo.selected = true;
            const orderBillingInfo = PaymentService.getOrderBillingInfoUI(billingAddress);
            const creditCardUserInputInfo = {
                errorCardInfo: {},
                fieldTouchedInfo: {},
                billingAddress,
                cardInfo,
            };

            return {
                ...state,
                creditCardUserInputInfo,
                selectedCardInfo: userPaymentInfo,
                showNewCreditCardForm: false,
                showEditCreditCardForm: true,
                showSameAsShippingAddressCheck: false,
                showEditBillingAddressForm: !!isAgentLogged(),
                orderBillingInfo,
            };
        }

        /**
         * Hide new credit card form if user added GC with full payment
         */
        case actionTypes.HIDE_NEW_CREDIT_CARD_FORM: {
            const creditCardUserInputInfo = {
                cardInfo: {},
                errorCardInfo: {},
                fieldTouchedInfo: {},
                emailId: get(state, 'creditCardUserInputInfo.emailId', ''),
                billingAddress: get(state, 'creditCardUserInputInfo.billingAddress', {}),
            };
            return {
                ...state,
                creditCardUserInputInfo,
                showNewCreditCardForm: false,
                showEditCreditCardForm: false,
                payPalEligible: false,
                orderEligibleForApplePay: false,
                showEditBillingAddressForm: !!isAgentLogged(),
            };
        }

        /**
         * Hide register user update credit card form
         */
        case actionTypes.HIDE_REGISTER_UPDATE_CREDIT_CARD_FORM: {
            let { creditCardUserInputInfo } = state;
            const { cardInfo } = creditCardUserInputInfo;
            const { selectedCardInfo = {} } = state;
            const paymentSource = get(selectedCardInfo, 'paymentSource', {});
            // Reseting all cardInfo values during hide cc form if cvv status in unverified
            if (
                User.isUserLoggedIn() &&
                (selectedCardInfo.status && selectedCardInfo.status.toUpperCase()) ===
                    PaymentConstants.UNVERIFIED_CARD_TYPE
            ) {
                cardInfo.isNumberEditable = false;
                cardInfo.type = paymentSource.type;
                cardInfo.expMonth = paymentSource.expiryMonth;
                cardInfo.expYear = paymentSource.expiryYear;
                cardInfo.number = paymentSource.cardNumber;
                cardInfo.cvvReentryRequired = selectedCardInfo.cvvReentryRequired;
                cardInfo.authMessageInfo = {
                    title: UNVERIFIED_AUTH.TITLE,
                    content: UNVERIFIED_AUTH.MESSAGE.CVVAuthFailMessage,
                };
            }
            creditCardUserInputInfo = { ...creditCardUserInputInfo, cardInfo };
            if (!selectedCardInfo.isITRM && !selectedCardInfo.cvvReentryRequired) {
                creditCardUserInputInfo = {};
            }
            map(state.userPaymentList, (payment) => {
                // eslint-disable-next-line no-param-reassign
                payment.selected = payment.id === state.selectedCardInfo.id;
            });
            return {
                ...state,
                creditCardUserInputInfo,
                showEditCreditCardForm: false,
                showEditBillingAddressForm: !!isAgentLogged(),
            };
        }

        /*
         * set address standardization required or not
         */
        case actionTypes.SET_ADDRESS_STAND_NOT_REQUIRED: {
            return { ...state, xStandardizationNotRequired: action.value };
        }

        /**
         * Show/Hide billing address form
         */
        case actionTypes.SHOW_BILLING_ADDRESS_FORM: {
            const cardInfo = { ...state.creditCardUserInputInfo.cardInfo };
            let { creditCardUserInputInfo } = state;
            if (action.value && User.isUserLoggedIn() && !cardInfo.isNumberEditable) {
                cardInfo.isNumberEditable = true;
                cardInfo.authMessageInfo = {
                    title: TEMPCARDNUMBERRENTRYREQUIRED_AUTH.TITLE,
                    content: TEMPCARDNUMBERRENTRYREQUIRED_AUTH.MESSAGE,
                };
                const cardInfoNumber = (cardInfo.cardName || '').trim().slice(-4);
                cardInfo.placeholder = `Re-enter card ending in ${cardInfoNumber}`;
                cardInfo.number = '';
                cardInfo.type = '';
                cardInfo.expMonth = '';
                cardInfo.expYear = '';
                creditCardUserInputInfo = { ...state.creditCardUserInputInfo, cardInfo };
            }
            return {
                ...state,
                creditCardUserInputInfo,
                showEditBillingAddressForm: isAgentLogged() ? true : action.value,
            };
        }

        /**
         * Show add new credit card form
         */
        case actionTypes.TOGGLE_NEW_CREDIT_CARD_FORM: {
            const updatedState = {
                showNewCreditCardForm: false,
                creditCardUserInputInfo: {},
            };
            if (!isEmpty(state.userPaymentList)) {
                /**
                 * Read payment from order
                 */
                const isPartialGiftcardPayment = PaymentService.isPartialGiftcardPayment(
                    action.orderDetailsInfo
                );
                const orderDetailsCardInfo = get(
                    action.orderDetailsInfo,
                    'data.billing.creditCards.cards[0]',
                    {}
                );
                let paymentId = get(
                    orderDetailsCardInfo,
                    'relationships.accountPaymentMethod.id',
                    orderDetailsCardInfo.id
                );

                if (isEmpty(paymentId)) {
                    /**
                     * Read express payment from profile if no payment from orders
                     */
                    let defaultPayment = find(
                        state.userPaymentList,
                        (payment) => payment.paymentSource.expressCheckout
                    );
                    if (isEmpty(defaultPayment)) {
                        /**
                         * Read default payment from profile if no express payment
                         */
                        defaultPayment = find(
                            state.userPaymentList,
                            (payment) => payment.paymentSource.isDefault
                        );
                    }
                    paymentId = defaultPayment ? defaultPayment.id : state.userPaymentList[0].id;
                }
                updatedState.userPaymentList = PaymentService.selectedPaymentUpdateInPaymentList(
                    paymentId,
                    state.userPaymentList
                );
                updatedState.selectedCardInfo = find(updatedState.userPaymentList, {
                    id: paymentId,
                });
                updatedState.isPartialGiftcardPayment = isPartialGiftcardPayment;
                updatedState.isPaypalPaymentAdded = false;
                // TODO to clean up this Code(duplicate to move this on Service)
                if (
                    updatedState.selectedCardInfo &&
                    (updatedState.selectedCardInfo.isITRM ||
                        updatedState.selectedCardInfo.cvvReentryRequired)
                ) {
                    const { orderPaymentInfo, options } = action;
                    const { paymentFromProfile } = state;
                    const isPromoFinanceApplied = PaymentService.isPromoFinanceApplied(
                        action.orderDetailsInfo
                    );
                    options.selectedPaymentId = paymentId;
                    options.isPromoFinanceApplied = isPromoFinanceApplied;
                    const formattedUserPaymentList = PaymentService.getUserPaymentListUIMapFromAPI(
                        paymentFromProfile,
                        orderPaymentInfo,
                        options
                    );
                    const cardInfo = PaymentService.getCreditCardUIMapFromAPI(
                        updatedState.selectedCardInfo,
                        options.context
                    );
                    const billingAddress = updatedState.selectedCardInfo.paymentSource.address;
                    billingAddress.phone = formatPhoneNumber(billingAddress.phone);
                    const creditCardUserInputInfo = {
                        errorCardInfo: {},
                        fieldTouchedInfo: {},
                        billingAddress,
                        cardInfo,
                    };
                    updatedState.userPaymentList = formattedUserPaymentList;
                    updatedState.creditCardUserInputInfo = creditCardUserInputInfo;
                    updatedState.selectedCardInfo =
                        find(formattedUserPaymentList, {
                            id: paymentId,
                        }) || updatedState.selectedCardInfo;
                }
            }
            return { ...state, ...updatedState };
        }

        /**
         * Update credit card form based on user input
         */
        case actionTypes.UPDATE_CREDIT_CARD_FORM: {
            const { attribute } = action;
            const { newValue } = action;
            const { creditCardUserInputInfo = {} } = state;
            let { cardInfo = {} } = creditCardUserInputInfo;
            const { errorCardInfo = {} } = creditCardUserInputInfo;
            const { fieldTouchedInfo = {} } = creditCardUserInputInfo;
            if (attribute === 'cvv' && !fieldTouchedInfo.cvv) {
                fieldTouchedInfo.cvv = true;
            }
            const additionalInfoFieldMap = {
                emailId: 'emailId',
                emailSubscription: 'emailSubscription',
            };
            if (additionalInfoFieldMap[attribute]) {
                creditCardUserInputInfo[attribute] = newValue;
            } else if (attribute === 'phone') {
                if (newValue.length < PaymentConstants.PHONE_NUMBER_MAX_LENGTH) {
                    creditCardUserInputInfo.billingAddress.phone = ShippingService.getFormattedPhoneNumber(
                        newValue
                    );
                }
            } else {
                const oldValue = cardInfo[attribute];
                cardInfo[attribute] = newValue;
                const shouldRestrictMarketplaceCardEntry =
                    state.hasMarketplaceItemsInCart &&
                    state.showNewCreditCardForm &&
                    (!cardInfo.id || !state.showEditCreditCardForm);
                const options = {
                    type: cardInfo.type,
                    context: action.options.context,
                    cardInfo,
                    oldValue,
                    shouldRestrictMarketplaceCardEntry,
                };
                const updatedCardInfo = PaymentService.getCreditCardUIMapFromUserInput(
                    attribute,
                    newValue,
                    options
                );
                cardInfo = { ...cardInfo, ...updatedCardInfo };
                /**
                 * Set invalid expire month error message if selected month is expired
                 */
                if (
                    attribute === 'expYear' &&
                    get(state.creditCardUserInputInfo, 'cardInfo.expMonth') &&
                    updatedCardInfo.expMonth === ''
                ) {
                    errorCardInfo.expMonth = validateRequired('', 'creditCardMonth');
                }
            }
            /*
             * Reset error if input value is correct format
             */
            const updatedPaymentState = {
                ...state,
                creditCardUserInputInfo: {
                    ...creditCardUserInputInfo,
                    cardInfo,
                },
            };
            const errorMessage =
                validateCreditCardFormField(
                    updatedPaymentState,
                    attribute,
                    action.options.context
                ) || '';
            const showMarketplaceRestrictedCardError =
                attribute === 'number' &&
                isMarketplaceRestrictedCardEntry(updatedPaymentState, action.options.context);

            if (
                showMarketplaceRestrictedCardError ||
                state.creditCardUserInputInfo?.fieldTouchedInfo?.[attribute] ||
                isEmpty(errorMessage)
            ) {
                errorCardInfo[attribute] = errorMessage;
            }
            if (attribute === 'number' && !showMarketplaceRestrictedCardError) {
                errorCardInfo.number = '';
            }
            /**
             * Should not show error message if card type is not recongized
             */
            if (!cardInfo.type) {
                errorCardInfo.cvv = '';
                errorCardInfo.expMonth = '';
                errorCardInfo.expYear = '';
            }
            fieldTouchedInfo[attribute] = true;
            const updatedCreditCardUserInputInfo = {
                ...creditCardUserInputInfo,
                cardInfo,
                errorCardInfo,
                fieldTouchedInfo,
            };

            return { ...state, creditCardUserInputInfo: updatedCreditCardUserInputInfo };
        }

        /**
         * Update credit card form error if user tap on review button
         */
        case actionTypes.UPDATE_CREDIT_CARD_FORM_ERROR: {
            const errorCardInfo = action.errorInfo;
            const creditCardUserInputInfo = { ...state.creditCardUserInputInfo, errorCardInfo };
            return { ...state, creditCardUserInputInfo };
        }

        /**
         * Update credit card form error based on user input
         */
        case actionTypes.UPDATE_CREDIT_CARD_FORM_FIELD_ERROR: {
            const { attribute } = action;
            const { errorCardInfo } = state.creditCardUserInputInfo;
            const { fieldTouchedInfo } = state.creditCardUserInputInfo;
            const errorMessage = validateCreditCardFormField(
                state,
                attribute,
                action.options.context
            );
            if (errorMessage === errorCardInfo[attribute] && fieldTouchedInfo[attribute] === true) {
                return state;
            }
            if (errorMessage) {
                errorCardInfo[attribute] = errorMessage;
            }
            fieldTouchedInfo[attribute] = true;
            const creditCardUserInputInfo = {
                ...state.creditCardUserInputInfo,
                errorCardInfo,
                fieldTouchedInfo,
            };
            return { ...state, creditCardUserInputInfo };
        }

        case actionTypes.UPDATE_PROFILE_PAYMENT_LIST: {
            const { paymentFromProfile, orderDetailsInfo, options } = action;
            const userPaymentInfo = get(orderDetailsInfo, 'data.billing.creditCards.cards[0]', {});
            const initiatedFromAdjustment = get(action.options, 'initiatedFromAdjustment', false);
            const isPromoFinanceApplied = PaymentService.isPromoFinanceApplied(orderDetailsInfo);
            const isPartialGiftcardPayment = PaymentService.isPartialGiftcardPayment(
                orderDetailsInfo
            );
            const isPaypalPaymentAdded = PaymentService.isPaypalPaymentAdded(orderDetailsInfo);
            options.isPaypalPaymentAdded = isPaypalPaymentAdded;
            options.isPromoFinanceApplied = isPromoFinanceApplied;
            const payPalEligible = PaymentService.isPaypalEligible(orderDetailsInfo, options);
            const orderEligibleForApplePay = orderDetailsInfo.applePayEligible;
            const showEditBillingAddressForm = false;
            const showSameAsShippingAddressCheck = false;
            const billingAddressInfo =
                get(orderDetailsInfo, 'data.billing.creditCards.cards[0].address') ||
                get(orderDetailsInfo, 'data.billing.unnamed.address') ||
                {};
            let orderBillingInfo = PaymentService.getOrderBillingInfoUI(billingAddressInfo);
            if (isPaypalPaymentAdded) {
                const billingPaypalAddress = get(
                    orderDetailsInfo,
                    'data.billing.paypal.address',
                    {}
                );
                orderBillingInfo = PaymentService.getOrderBillingInfoUI(
                    billingPaypalAddress,
                    isPaypalPaymentAdded
                );
                orderBillingInfo.imageURL = imagePath(options.context, 'paypal.svg');
            }
            let isPaypalOrApplePaySelected =
                isPaypalPaymentAdded ||
                (state.isPaypalOrApplePaySelected && isPartialGiftcardPayment);
            if (state.isBnplSelected) {
                isPaypalOrApplePaySelected = false;
            }
            const updatedState = {
                payPalEligible,
                orderEligibleForApplePay,
                isPartialGiftcardPayment,
                isPaypalPaymentAdded,
                isPaypalOrApplePaySelected,
            };

            if (!initiatedFromAdjustment) {
                const userPaymentList = PaymentService.getUserPaymentListUIMapFromAPI(
                    paymentFromProfile,
                    userPaymentInfo,
                    options
                );
                const selectedPayment = find(userPaymentList, { selected: true }) || {};
                if (selectedPayment.isITRM || selectedPayment.cvvReentryRequired) {
                    const cardInfo = PaymentService.getCreditCardUIMapFromAPI(
                        selectedPayment,
                        action.options.context
                    );
                    const billingAddress = selectedPayment.paymentSource.address;
                    billingAddress.phone = formatPhoneNumber(billingAddress.phone);
                    updatedState.creditCardUserInputInfo = {
                        fieldTouchedInfo: {},
                        errorCardInfo: {},
                        billingAddress,
                        cardInfo,
                    };
                    updatedState.selectedCardInfo = selectedPayment;
                }
                updatedState.paymentFromProfile = paymentFromProfile;
                updatedState.userPaymentList = userPaymentList;
                updatedState.showNewCreditCardForm = false;
                updatedState.showEditCreditCardForm = false;
                updatedState.orderBillingInfo = orderBillingInfo;
                updatedState.showSameAsShippingAddressCheck = showSameAsShippingAddressCheck;
                updatedState.showEditBillingAddressForm = isAgentLogged()
                    ? true
                    : showEditBillingAddressForm;
                updatedState.pageRenderTime = new Date().getTime();
            }

            return { ...state, ...updatedState };
        }

        case actionTypes.SET_DEFAULT_PREFERENCE_CREDIT_CARD_TO_PROFILE: {
            const { cardInfo } = state.creditCardUserInputInfo;
            cardInfo.isExpressCheckout = action.value;
            if (cardInfo.isExpressCheckout) {
                cardInfo.saveCardToProfile.selected = true;
            }
            const creditCardUserInputInfo = { ...state.creditCardUserInputInfo, cardInfo };
            return { ...state, creditCardUserInputInfo };
        }

        case actionTypes.SET_SAVE_CREDIT_CARD_TO_PROFILE: {
            const { cardInfo } = state.creditCardUserInputInfo;
            cardInfo.saveCardToProfile.selected = action.value;
            cardInfo.isExpressCheckout = false;
            const creditCardUserInputInfo = { ...state.creditCardUserInputInfo, cardInfo };
            return { ...state, creditCardUserInputInfo };
        }

        case actionTypes.SET_DELETE_CONFIRMATIONMODAL_INFO: {
            const deleteConfirmation = {};
            if (action.show) {
                deleteConfirmation.showDeleteConfirmationModal = true;
                deleteConfirmation.paymentId = action.paymentId;
            }
            return { ...state, deleteConfirmation };
        }

        case actionTypes.SELECT_USER_PAYMENT: {
            const { paymentId } = action;
            const isPromoFinanceApplied = find(state.userPaymentList, {
                isPromoFinanceApplied: true,
            });
            const userPaymentList = PaymentService.selectedPaymentUpdateInPaymentList(
                paymentId,
                state.userPaymentList
            );
            const selectedCardInfo = find(userPaymentList, { selected: true });
            const updatedState = {
                userPaymentList,
                selectedCardInfo,
                showNewCreditCardForm: false,
                creditCardUserInputInfo: {},
                isPaypalPaymentAdded: false,
            };
            if (
                selectedCardInfo &&
                (selectedCardInfo.isITRM || selectedCardInfo.cvvReentryRequired)
            ) {
                const { orderPaymentInfo, options } = action;
                const { paymentFromProfile } = state;
                options.selectedPaymentId = paymentId;
                options.isPromoFinanceApplied = isPromoFinanceApplied;
                const formattedUserPaymentList = PaymentService.getUserPaymentListUIMapFromAPI(
                    paymentFromProfile,
                    orderPaymentInfo,
                    options
                );
                const cardInfo = PaymentService.getCreditCardUIMapFromAPI(
                    selectedCardInfo,
                    options.context
                );
                const billingAddress = selectedCardInfo.paymentSource.address;
                billingAddress.phone = formatPhoneNumber(billingAddress.phone);
                const creditCardUserInputInfo = {
                    errorCardInfo: {},
                    fieldTouchedInfo: {},
                    billingAddress,
                    cardInfo,
                };
                updatedState.userPaymentList = formattedUserPaymentList;
                updatedState.creditCardUserInputInfo = creditCardUserInputInfo;
                updatedState.selectedCardInfo = selectedCardInfo;
            }

            return { ...state, ...updatedState };
        }
        /**
         * Initialize Gift Card form for guest and register user
         */
        case actionTypes.GET_GIFT_CARD_LIST: {
            const { orderDetailsInfo } = action;
            const isNative = get(action, 'options.context.isNative', false);
            const initiatedFromAdjustment = get(action.options, 'initiatedFromAdjustment', false);
            const bagItems = get(orderDetailsInfo, 'data.bag.items', []);
            const isGiftCardOrderPresent = isGiftCardOrder(bagItems);
            const orderTotalExceededDefaultLimit = get(
                orderDetailsInfo,
                'data.orderTotalExceededDefaultLimit',
                false
            );
            const isGiftCardEnabled = !isGiftCardOrderPresent && !orderTotalExceededDefaultLimit;
            const appliedGiftCardList = get(orderDetailsInfo, 'data.billing.unnamed.giftCards', []);
            const appliedCreditCard = get(orderDetailsInfo, 'data.billing.creditCards.cards', []);
            const appliedPaypal = get(orderDetailsInfo, 'data.billing.paypal', false);
            const noOtherPaymentMethod = appliedCreditCard.length === 0 && !appliedPaypal;
            const totalBalance = find(orderDetailsInfo.data.totals, { type: 'BALANCE' }) || {};
            const isHasRemainingBalance = totalBalance.amount > 0 && noOtherPaymentMethod;
            const isAppliedGiftCardExist = appliedGiftCardList.length > 0;
            const giftCardForm = { ...get(state, 'giftCardInfo.giftCardForm', {}) };
            let remainingBalanceMessage = '';
            if (isHasRemainingBalance) {
                const ctaBalance = isAppliedGiftCardExist ? totalBalance.amount : 0;
                let errorMessage = GC_CTA_MESSAGE_1;
                errorMessage += currencyFormatter.format(ctaBalance, { code: CURRENCY_US });
                errorMessage += GC_CTA_MESSAGE_2;
                remainingBalanceMessage = errorMessage;
            }
            const buttonCTALabel = isAppliedGiftCardExist ? ADD_ANOTHER_GIFT_CARD : ADD_GIFT_CARD;
            const giftCardInfo = {
                appliedGiftCardList,
                remainingBalanceMessage,
                buttonCTALabel,
                isGiftCardEnabled,
                giftCardForm,
            };

            if (!initiatedFromAdjustment) {
                giftCardInfo.showGiftCardForm = get(state, 'giftCardInfo.showGiftCardForm', false);
                giftCardInfo.showAddGiftCardLink = giftCardInfo.showGiftCardForm
                    ? false
                    : totalBalance.amount > 0 && appliedGiftCardList.length < MAXALLOWEDGIFTCARD;
            } else {
                const totalBalanceAmount = totalBalance.amount > 0;
                if (totalBalanceAmount) {
                    giftCardInfo.showAddGiftCardLink =
                        appliedGiftCardList.length < MAXALLOWEDGIFTCARD;
                } else {
                    giftCardInfo.showAddGiftCardLink = false;
                    giftCardInfo.showGiftCardForm = false;
                }
            }
            if (isNative) {
                giftCardInfo.isAppWalletGCFetched = get(
                    state,
                    'giftCardInfo.isAppWalletGCFetched',
                    false
                );
            }
            return { ...state, giftCardInfo };
        }
        /**
         * show or hide gift card form.
         */
        case actionTypes.SHOW_HIDE_GIFTCARD_FORM: {
            const showGiftCardForm = action.showHideGiftCardFormFlag;
            const giftCardForm = {
                giftCardNumber: '',
                securityCode: '',
                errorInfo: {},
            };
            const giftCardInfo = { ...state.giftCardInfo };
            const appliedGiftCardList = get(giftCardInfo, 'appliedGiftCardList', []);
            giftCardInfo.showAddGiftCardLink =
                !showGiftCardForm && appliedGiftCardList.length < MAXALLOWEDGIFTCARD;
            giftCardInfo.showGiftCardForm = showGiftCardForm;
            giftCardInfo.giftCardForm = giftCardForm;
            const creditCardUserInputInfo = { ...state.creditCardUserInputInfo };
            /**
             *  MCYODA-25623 MCYODA-21453
             *  should not clear CC / Paypal contactInfoError on Add/Remove GC
             */
            // const errorCardInfo = {};
            // if (creditCardUserInputInfo && creditCardUserInputInfo.errorCardInfo) {
            //     creditCardUserInputInfo = { ...state.creditCardUserInputInfo, errorCardInfo };
            // }

            return { ...state, giftCardInfo, creditCardUserInputInfo };
        }
        /**
         * Gift card form error based on user input
         */
        case actionTypes.GIFT_CARD_FORM_FIELD_ERROR: {
            const { attribute, enableV2GiftCardForm } = action;
            const errorCardInfo = get(state, 'giftCardInfo.giftCardForm.errorInfo', {});
            const errorMessage = validateGiftCardFormField(state, attribute, enableV2GiftCardForm);
            errorCardInfo[attribute] = '';
            if (!isEmpty(errorMessage)) {
                errorCardInfo[attribute] = errorMessage;
            }
            const giftCardForm = { ...state.giftCardInfo.giftCardForm };
            giftCardForm.errorInfo = errorCardInfo;
            const giftCardInfo = { ...state.giftCardInfo };
            giftCardInfo.giftCardForm = giftCardForm;
            return { ...state, giftCardInfo };
        }
        /**
         * Gift card number & Gift Card Code value on user input
         */
        case actionTypes.GIFT_CARD_FORM_CHANGE_VALUE: {
            const { attribute, enableV2GiftCardForm } = action;
            const giftCardForm = { ...state.giftCardInfo.giftCardForm };
            let newValue = action.newValue.replace(/[^(0-9)]/g, '');
            if (attribute === 'giftCardNumber' && newValue.length > 19) {
                newValue = newValue.substring(0, 19);
            } else if (
                attribute === 'securityCode' &&
                newValue.length > (enableV2GiftCardForm ? 8 : 4)
            ) {
                newValue = newValue.substring(0, enableV2GiftCardForm ? 8 : 4);
            }
            const errorCardInfo = get(state, 'giftCardInfo.giftCardForm.errorInfo', {});
            const newGiftCardPayment = {
                giftCardInfo: {
                    giftCardForm: {},
                },
            };
            newGiftCardPayment.giftCardInfo.giftCardForm[attribute] = newValue;
            const errorMessage = validateGiftCardFormField(
                newGiftCardPayment,
                attribute,
                enableV2GiftCardForm
            );
            errorCardInfo[attribute] = '';
            if (!isEmpty(errorMessage)) {
                errorCardInfo[attribute] = errorMessage;
            }
            giftCardForm.errorInfo = errorCardInfo;
            giftCardForm[action.attribute] = newValue;
            const giftCardInfo = { ...state.giftCardInfo };
            giftCardInfo.giftCardForm = giftCardForm;
            return { ...state, giftCardInfo };
        }
        /**
         * Update Apply Gift card form error if user tab on Apply Gift card button
         */
        case actionTypes.GIFT_CARD_FORM_ERROR: {
            const { errorInfo } = action;
            const giftCardForm = { ...state.giftCardInfo.giftCardForm };
            giftCardForm.errorInfo = errorInfo;
            const giftCardInfo = { ...state.giftCardInfo };
            giftCardInfo.giftCardForm = giftCardForm;
            return { ...state, giftCardInfo };
        }
        case actionTypes.GIFT_CARDS_FROM_APP: {
            const { payload = [] } = action;
            let appGiftCardList = [...get(state, 'appGiftCardList', [])];
            const giftCardInfo = { ...state.giftCardInfo };
            giftCardInfo.isAppWalletGCFetched = true;
            appGiftCardList = payload;
            return { ...state, giftCardInfo, appGiftCardList };
        }
        case actionTypes.GIFT_CARDS_BALANCE_FROM_APP: {
            const { payload = {} } = action;
            const appGCBalance = { ...payload };
            return { ...state, appGCBalance };
        }
        /**
         * To display Special Discount for New Customer to use New JCPenney Credit Card
         * To get Extra some % discount
         */
        case actionTypes.GET_SPECIAL_DISCOUNT_INFO: {
            const { orderDetailsInfo } = action;
            const adjustments = get(orderDetailsInfo, 'data.adjustments', []);
            const specialDiscount =
                find(adjustments, { rewardCategory: ADJUSTMENT_TYPE_NEW_CUSTOMER }) || false;
            let percentageOff = '';
            if (specialDiscount && specialDiscount.percentageOff) {
                percentageOff = getFormattedValue(specialDiscount.percentageOff);
            }
            return { ...state, specialDiscountPercentageOff: percentageOff };
        }

        case actionTypes.CLEAR_AUTH_MESSAGE: {
            const cardInfo = { ...state.creditCardUserInputInfo.cardInfo };
            cardInfo.authMessageInfo = {};
            const creditCardUserInputInfo = { ...state.creditCardUserInputInfo, cardInfo };
            return { ...state, creditCardUserInputInfo };
        }
        case actionTypes.SET_HAS_MARKETPLACE_ITEMS_IN_CART: {
            return { ...state, hasMarketplaceItemsInCart: action.value };
        }
        default:
            return state;
    }
}
